export default [
  {
    path: '/admin/autojs/record',
    name: 'autojsRecord',
    component: () => import('@/views/admin/autojs/record.vue'),
    meta: { title: '自动评论记录', requireAuth: true }
  }
]
